import "core-js/modules/es6.regexp.split";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import earlyBirdQuery from '~/graphql/earlyBird.gql';

var GlobalTitle = function GlobalTitle() {
  return import('~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

var ProductsCarousel = function ProductsCarousel() {
  return import('~/components/organisms/Global/ProductsCarousel.vue');
};

var Cta = function Cta() {
  return import('~/components/atoms/Cta.vue');
};

export default {
  name: 'ProductsCarouselEb',
  components: {
    GlobalTitle: GlobalTitle,
    ProductsCarousel: ProductsCarousel,
    Cta: Cta
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      earlyBird: []
    };
  },
  apollo: {
    earlyBird: {
      query: earlyBirdQuery,
      variables: function variables() {
        return {
          locale: this.locale.iso,
          widgetId: this.currentPayload.ebWidgetId,
          profileId: this.profileId,
          limit: this.currentPayload.totalProduct
        };
      }
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    currentPayload: function currentPayload() {
      var _ref;

      return {
        title: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? (_ref = _ref.title) != null ? _ref[0] : _ref : _ref : _ref) || {},
        ebWidgetId: this.payload.primary.cross_sell_widget_id || null,
        totalProduct: this.payload.primary.cross_total_products || 20,
        ctaText: this.payload.primary.cta_text || '',
        ctaLink: this.payload.primary.cta_link || '',
        trackingData: {
          event_label: this.payload.primary.event_label || null,
          event_category: this.payload.primary.event_category || null,
          event_action: this.payload.primary.event_action || null
        }
      };
    },
    profileId: function profileId() {
      return this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : '';
    }
  }),
  methods: {
    clickTracking: function clickTracking(event) {
      this.$root.$emit('generic-tracking', event, {
        data: this.currentPayload.trackingData
      });
    }
  }
};